import React from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';

function AppContent() {
  const { user, token, loading, logout } = useAuth();
  if (loading) return (
    <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100vh',background:'#0f172a',color:'#f1f5f9',fontSize:'24px'}}>⚡</div>
  );
  return user ? <Dashboard token={token} onLogout={logout} /> : <Login />;
}

export default function App() {
  return <AuthProvider><AppContent /></AuthProvider>;
}
